export { default as useAddInfiniteIndexQueryItemCache } from './useAddInfiniteIndexQueryItemCache';
